<script>
export default {
  props: {
    heroImg: { type: String, required: true },
  },
}
</script>

<template>
  <section class="bg-gray-300">
    <div
      class="hero-container bg-cover bg-center"
      :style="{ 'background-image': `url(${heroImg})` }"
    />
  </section>
</template>
